<app-dialog
  [title]="'priceReset.title' | translate"
  [confirmation]="'priceReset.button' | translate"
  (save)="onSubmit()"
>
  <div id="price-reset-dialog">
    <div mat-dialog-content>
      <p>{{ 'priceReset.description' | translate }}</p>
    </div>
    <ng-container *ngIf="!isLoadingData; else loader">
      <form [formGroup]="formGroup" class="d-flex flex-column">
        <div>
          <mat-checkbox formControlName="price_msrp">
            {{ 'priceReset.prices.priceMsrp' | translate }}
          </mat-checkbox>
        </div>
        <div>
          <mat-checkbox formControlName="price_advert">
            {{ 'priceReset.prices.priceAdvert' | translate }}
          </mat-checkbox>
        </div>
        <div class="d-flex flex-column">
          <mat-checkbox formControlName="price_invoice">
            {{ 'priceReset.prices.priceInvoice' | translate }}
          </mat-checkbox>
        </div>
        <div>
          <mat-checkbox formControlName="price_variable">
            {{ 'priceReset.prices.priceVariable' | translate }}
          </mat-checkbox>
        </div>
        <div>
          <mat-checkbox formControlName="price_web">
            {{ 'priceReset.prices.priceWeb' | translate }}
          </mat-checkbox>
        </div>
        <div>
          <mat-checkbox formControlName="price_wholesale">
            {{ 'priceReset.prices.priceWholesale' | translate }}
          </mat-checkbox>
        </div>
      </form>
    </ng-container>

    <ng-template #loader>
      <ngx-skeleton-loader [theme]="{ width: '100%', height: '50px' }"></ngx-skeleton-loader>
    </ng-template>
  </div>
</app-dialog>

